import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl, loggedUser } from "../../../../Utility/constants";
import AdminHeader from "../../../common/AdminHeader";
import Footer from "../../../common/Footer";
import "./TeacherDetails.css";
import EditTeacherDetailsModal from "./EditTeacherDetailsModal";
import TeacherDetailsList from "./TeacherDetailsList";
import AddNewTeacherModal from "./AddNewTeacherModal";
import TeacherDetailsModal from "./TeacherDetailsModal";
import TeacherSubjectClassDetailsModal from "./TeacherSubjectClassDetailsModal";
import UserTeacherDocumentMasterModal from "./UserTeacherDocumentMasterModal";

const TeacherDetailsPage = () => {
  const [data, setData] = useState([]);
  const [selectedTeacherId, setSelectedTeacherId] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showClassSubjectModal, setShowClassSubjectModal] = useState(false);
  const [teacherClassSubjectData, setTeacherClassSubjectData] = useState([]);
  const [showDocumentModal, setShowDocumentModal] = useState(false);

  const [teacherDetails, setTeacherDetails] = useState(null);
  const [adminSelectedSchoolId, setAdminSelectedSchoolId] = useState(null);
  const [schoolwebsite, setSchoolwebsite] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const loggedUserRole = localStorage.getItem("Role");
  const loggedUserId = localStorage.getItem("userID");

  const [formData, setFormData] = useState({
    fullName: "",
    gender: "",
    dateOfBirth: "",
    address: "",
    phone: "",
    email: "",
    password: "",
    joiningDate: "",
    designation: "",
    salary: 0,
    // NEW FIELDS
    aadhaarCardNumber: "",
    grantTypes: "",
    educationalQualification: "",
    payScaleSalary: "",
    chartType: "",
    postType: "",
    retirementDate: "",
    payGradeSanctionedDate: "",
    selectionCategoryApprovedDate: "",
    teacherCategoryId: "",
    vaiyaktikManyata: "",
    vaiyaktikManyataDate: "",
    vaiyaktikManyataOutwardNumber: "",
    vaiyaktikManyataPhoto: "",
    teacherPhoto: "",

    createdBy: localStorage.getItem("userID"),
    updatedBy: localStorage.getItem("userID"),
    teacherType: ""
  });

  useEffect(() => {
    fetchData();
    fetchAdminSchoolId();
  }, []);

  const fetchData = async () => {
    try {      
      
      const url = loggedUserRole === "ADMIN" ? `${baseUrl}/api/Teachers` 
      : `${baseUrl}/api/Teachers/GetTeacherDetailsByTeacherId?teacherId=${loggedUserId}`;
      const response = await axios.get(url);
      if (
        response &&
        response.data &&
        response.data.length > 0
      ) {
        setData(response.data);
      }
      else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    axios
      .get(`${baseUrl}/api/SchoolGeneralInfo`)
      .then((response) => {
        setSchoolwebsite(response?.data?.slice(0, 1)[0]?.websiteName);
        setSchoolName(response?.data?.slice(0, 1)[0]?.schoolOrCollegeName);

      })
      .catch((error) => {
        toast.error("Failed to load school details.");
      });
  }, []);

  const fetchAdminSchoolId = async () => {
    try {
      const url = `${baseUrl}/api/PersonalDetails/PersonalDetailsByAdmin?AdminId=${localStorage.getItem(
        "userID"
      )}`;
      const response = await axios.get(url);
      if (response && response.data && response.data && response.data.length > 0) {
        setAdminSelectedSchoolId(response.data[0].schoolId);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleOpenDocumentModal = (teacherId) => {
    setSelectedTeacherId(teacherId);
    setShowDocumentModal(true);
  };

  const handleAdd = async () => {
    setShowAddNewModal(true);
  };

  const handleEdit = async (teacherId) => {
    try {
      setSelectedTeacherId(teacherId);
      const response = await axios.get(`${baseUrl}/api/Teachers/${teacherId}`);
      console.log(response.data);
      setEditItem(response.data);
      setShowEditModal(true);
    } catch (error) {
      console.error("Error fetching item details", error);
    }
  };

  const handleView = async (teacherId) => {
    try {
      const response = await axios.get(`${baseUrl}/api/Teachers/GetTeacherDetails?id=${teacherId}`);
      setTeacherDetails(response.data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student details", error);
    }
  };

  const handleClassSubjectView = async (teacherClassSubjectData) => {
    try {
      setTeacherClassSubjectData(teacherClassSubjectData);
      setShowClassSubjectModal(true);
    } catch (error) {
      console.error("Error fetching student details", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const fd = new FormData();

      // Append all editable fields
      Object.keys(editItem).forEach((key) => {
        if (editItem[key] !== null && editItem[key] !== undefined) {
          fd.append(key, editItem[key]);
        }
      });

      // Add teacher Id
      fd.append("Id", selectedTeacherId);
      fd.append("UpdatedBy", localStorage.getItem("userID"));

      const response = await axios.put(
        `${baseUrl}/api/Teachers/${selectedTeacherId}`,
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success("Details updated successfully!");
      setShowEditModal(false);
      resetEditTeacherForm();
      fetchData();

    } catch (error) {
      if (error?.response?.data) {
        toast.error(error.response.data)
      }
      else {
        console.error(error);
        toast.error("Failed to update user.");
      }
    }
  };


  const handleDelete = async (teacherId) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        await axios.delete(`${baseUrl}/api/Teachers/${teacherId}`);
        toast.success("Record deleted successfully!");
        fetchData();
      } catch (error) {
        console.error("Error deleting record", error);
        toast.error("Error deleting record.");
      }
    }
  };

  const handleUpdateStatus = async (statusData) => {
    
    if (window.confirm("Are you sure you want to update this record?")) {
      try {
        const fd = new FormData();

        fd.append("status", statusData.status);

        await axios.patch(
          `${baseUrl}/api/Teachers/UpdateTeacherStatus/${statusData.teacherId}`,
          fd
        );

        toast.success("Status updated successfully!");
        fetchData();
      } catch (error) {
        console.error("Error updating record", error);
        toast.error("Error updating record.");
      }
    }
  };

  const handleNewTeacherSubmit = async (e) => {

    e.preventDefault();

    try {
      const fd = new FormData();

      // Append all fields
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null && formData[key] !== undefined) {
          fd.append(key, formData[key]);
        }
      });

      // Add School ID
      fd.append("schoolId", adminSelectedSchoolId);
      fd.append("status", "APPROVED");

      const response = await axios.post(
        `${baseUrl}/api/Teachers`,
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success("User added successfully");
      setShowAddNewModal(false);
      resetAddTeacherForm();
      fetchData();
      const whatsappUrl = `https://chatbotmarketing.in/api/v1/whatsapp/send/template?apiToken=11446%7CxR4BBpvQmkRyJXIW0dWSneCK6L2zzDWkIe7KPDMB3c98b270&phone_number_id=693821633824945&template_id=224174&templateVariable-fullname-1=${formData.fullName}&templateVariable-websitename-2=${schoolwebsite}&templateVariable-aadharno-3=${formData.aadhaarCardNumber}&templateVariable-password-4=${formData.password}&templateVariable-role-5=${document.getElementById('formRole').value}&templateVariable-teachertype-6=${document.getElementById('formTeacherType').value}&templateVariable-schoolname-7=${schoolName}&phone_number=${formData.phone}`
      axios.get(whatsappUrl)
        .then((res) => {
          console.log("WhatsApp message sent successfully");
        })
        .catch((err) => {
          console.error("Failed to send WhatsApp message", err);
        });
    } catch (error) {
      if (error?.response?.data) {
        toast.error(error.response.data)
      }
      else {
        console.error(error);
        toast.error("Failed to save user.");
      }
    }
  };

  const resetAddTeacherForm = () => {
    setFormData({
      fullName: "",
      gender: "",
      dateOfBirth: "",
      address: "",
      phone: "",
      email: "",
      password: "",
      joiningDate: "",
      designation: "",
      salary: 0,

      aadhaarCardNumber: "",
      grantTypes: "",
      educationalQualification: "",
      payScaleSalary: "",
      chartType: "",
      postType: "",
      retirementDate: "",
      payGradeSanctionedDate: "",
      selectionCategoryApprovedDate: "",
      teacherCategoryId: "",
      vaiyaktikManyata: "",
      vaiyaktikManyataDate: "",
      vaiyaktikManyataOutwardNumber: "",
      vaiyaktikManyataPhoto: "",
      teacherPhoto: "",

      createdBy: localStorage.getItem("userID"),
      updatedBy: localStorage.getItem("userID"),
      teacherType: ""
    });
  };

  const resetEditTeacherForm = () => {
    setEditItem(null);
    setSelectedTeacherId("");
  };

  const handleSearch = async (searchCriteria, searchValue) => {
    if (!searchValue) {
      fetchData();
      return;
    }

    try {
      const response = await axios.get(
        `${baseUrl}/api/Teachers/GetTeachersDetails`,
        {
          params: {
            searchCriteria,
            searchValue,
            loggedUser,
          },
        }
      );
      setData(response.data);
      //setErrorMessage(""); // Reset any error messages
    } catch (error) {
      toast.error(
        error.response?.data || "Something went wrong while fetching data."
      );
      setData([]);
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5 mb-5">
        <TeacherDetailsList
          data={data}
          onEdit={handleEdit}
          onView={handleView}
          onDelete={handleDelete}
          onAddNewTeacher={handleAdd}
          onClassSubjectView={handleClassSubjectView}
          handleSearch={handleSearch}
          handleUpdateStatus={handleUpdateStatus}
          showhandleDocumentMaster={handleOpenDocumentModal}
        />
        {showDocumentModal && (
          <UserTeacherDocumentMasterModal
            showhandleDocumentMaster={showDocumentModal}
            handleDocumentMasterClose={() => {
              setShowDocumentModal(false);
              setSelectedTeacherId(null);
            }}
            teacherId={selectedTeacherId}
            refreshList={fetchData}
          />
        )}
        {showAddNewModal && (
          <AddNewTeacherModal
            showAddNew={showAddNewModal}
            handleCloseNewTeacher={() => {
              setShowAddNewModal(false)
              resetAddTeacherForm()
            }}
            handleNewTeacherSubmit={handleNewTeacherSubmit}
            newTeacherItem={formData}
            setNewTeacherItem={setFormData}
            schoolId={adminSelectedSchoolId}
          />
        )}
        {showModal && (
          <TeacherDetailsModal
            show={showModal}
            handleDetailsClose={() => setShowModal(false)}
            teacherDetails={teacherDetails}
          />
        )}

        {showClassSubjectModal && (
          <TeacherSubjectClassDetailsModal
            show={showClassSubjectModal}
            handleClassSubjectModalClose={() => setShowClassSubjectModal(false)}
            teacherClassSubjectData={teacherClassSubjectData}
          />
        )}
        {showEditModal && (
          <EditTeacherDetailsModal
            show={showEditModal}
            handleClose={() => {
              setShowEditModal(false)
              resetEditTeacherForm();
            }}
            handleSubmit={handleSubmit}
            editItem={editItem}
            setEditItem={setEditItem}
            schoolId={adminSelectedSchoolId}
          />
        )}
        {showDetailsModal && (
          <TeacherDetailsList
            show={showDetailsModal}
            handleDetailsClose={() => setShowDetailsModal(false)}
            teacherDetails={teacherDetails}
          />
        )}
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default TeacherDetailsPage;
